
export enum CheckoutPaymentMethodTypes {
    BillwerkCards = 1,
    BillwerkApplepay = 2,
    Betalingsservice = 4,
    MobilePay = 5,
    VippsRecurring = 6
}
